import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';

const NavbarComponent = () => {
  const { isAuthenticated, isAdmin, user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
      <Container>
        <Navbar.Brand as={Link} to="/">
          BITS Pilani Placement Portal
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {!isAuthenticated ? (
              <>
              </>
            ) : isAdmin ? (
              <>
                <Nav.Link as={Link} to="/admin/dashboard">Dashboard</Nav.Link>
                <Nav.Link as={Link} to="/admin/companies">Companies</Nav.Link>
                <Nav.Link as={Link} to="/admin/students">Students</Nav.Link>
                
                {/* Schedule Interviews Dropdown */}
                <NavDropdown title="Schedule Interviews" id="admin-scheduling-dropdown">
                  <NavDropdown.Item as={Link} to="/admin/global-scheduling">
                    All Interview
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/admin/scheduling">
                    Single Interview
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/admin/custom-scheduling">
                    Custom Schedule
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/admin/gd-scheduling">
                    GD Scheduling
                  </NavDropdown.Item>
                </NavDropdown>
                
                <Nav.Link as={Link} to="/developers">Developers</Nav.Link>
                
                <Navbar.Text className="mx-3">
                  Signed in as: <span className="text-white fw-bold">{user?.email}</span>
                </Navbar.Text>
                <Button variant="outline-light" size="sm" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
                <Nav.Link as={Link} to="/preferences">Companies</Nav.Link>
                <Nav.Link as={Link} to="/my-interview">Scheduled Interviews</Nav.Link>
                <Nav.Link as={Link} to="/developers">Developers</Nav.Link>
                <Navbar.Text className="mx-3">
                  Signed in as: <span className="text-white fw-bold">{user?.email}</span>
                </Navbar.Text>
                <Button variant="outline-light" size="sm" onClick={handleLogout}>
                  Logout
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavbarComponent;